import { render, staticRenderFns } from "./QuestionInfo.vue?vue&type=template&id=03df09d2"
import script from "./QuestionInfo.vue?vue&type=script&lang=js"
export * from "./QuestionInfo.vue?vue&type=script&lang=js"
import style0 from "./QuestionInfo.vue?vue&type=style&index=0&id=03df09d2&prod&lang=css&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports